import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Components/Home/Home";
import AppContext from "./context";
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContext>
          <Routes>
            <Route exact path="/" element={<Home />} />
          </Routes>
        </AppContext>
      </BrowserRouter>
    </div>
  );
}

export default App;
